<template>
	<div class="device-account">
		<gc-header header-data="voltageAccount">
			<template #ops>
				<el-button
					v-has="'monitor:nqi:pressure-regulator:ledger:add'"
					v-click-blur
					type="primary"
					@click="$router.push({ name: 'voltageAccountCreate' })"
				>
					新增调压器
				</el-button>
			</template>
		</gc-header>
		<div class="content">
			<div class="right">
				<div class="filter">
					<gc-advanced-filter
						ref="advancedFilter"
						v-model="params"
						:fields="filterFields"
						@search="handleFilterSearch"
						@reset="handleFilterReset"
					/>
					<gc-column-setting
						storageKey="localcolumn-voltage-account-v2"
						:columns="columns"
						@update-column="data => (columns = data)"
					></gc-column-setting>
				</div>
				<div class="table" v-loading="loading">
					<gc-table
						ref="deviceTable"
						border
						showPage
						:total="total"
						:columns="columnList"
						:table-data="tableData"
						:current-page.sync="currentPage"
						:page-size="pageSize"
						@current-page-change="handlePageChange"
						@size-change="handleSizeChange"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isBlank } from '@/utils/validate'
import { apiGetPressureRegulatorList, apiUnbindPressureRegulatorCollector } from '@/apis/pressureRegulatorManage.api'
export default {
	name: 'VoltageAccount',
	data() {
		return {
			params: {
				regulatorCode: null,
				brand: null,
				model: null,
				installAddress: null,
				cabinetNo: null,
				collectorDeviceNo: null,
				installDate: [],
			},
			tableData: [],
			total: 0,
			currentPage: 1,
			pageSize: 20,
			pageParams: {},
			loading: false,
			columns: [
				{
					key: 'regulatorCode',
					name: '调压器编号',
					tooltip: true,
					fixed: 'left',
					dragDisable: true,
					disabledSelect: true,
				},
				{
					key: 'brand',
					name: '品牌',
					tooltip: true,
				},
				{
					key: 'model',
					name: '型号',
					tooltip: true,
				},
				{
					key: 'installAddress',
					name: '安装地址',
					tooltip: true,
				},
				{
					key: 'installDate',
					name: '安装日期',
					tooltip: true,
				},
				{
					key: 'cabinetNo',
					name: '调压柜/箱编号',
					tooltip: true,
				},
				{
					key: 'collectorDeviceNo',
					name: '采集器编号',
					tooltip: true,
				},
				{
					key: 'subDeviceCount',
					name: '子设备数',
					tooltip: true,
				},
				{
					key: 'modifyTime',
					name: '修改时间',
					tooltip: true,
				},
				{
					key: 'oprate',
					name: '操作',
					width: '260px',
					fixed: 'right',
					dragDisable: true,
					disabledSelect: true,
					render: (h, row) => {
						const buttons = [
							h(
								'el-button',
								{
									props: { type: 'text', size: 'medium' },
									on: {
										click: () => this.handleDetail(row),
									},
								},
								'详情',
							),
							this.$has('monitor:nqi:pressure-regulator:ledger:edit')
								? h(
										'el-button',
										{
											props: { type: 'text', size: 'medium' },
											on: {
												click: () => this.handleEdit(row),
											},
										},
										'编辑',
								  )
								: null,
							this.$has([
								'monitor:nqi:pressure-regulator:ledger:bind-collector',
								'monitor:nqi:pressure-regulator:ledger:device-config',
							])
								? h(
										'el-button',
										{
											props: { type: 'text', size: 'medium' },
											on: {
												click: () => this.handleRelationConfig(row),
											},
										},
										'关联设备',
								  )
								: null,
						]
						if (
							row.collectorDeviceNo &&
							this.$has('monitor:nqi:pressure-regulator:ledger:unbind-collector')
						) {
							buttons.push(
								h(
									'el-button',
									{
										props: { type: 'text', size: 'medium' },
										style: { color: '#f56c6c' },
										on: {
											click: () => this.handleUnbind(row),
										},
									},
									'解绑设备',
								),
							)
						}
						return h('div', null, buttons)
					},
				},
			],
		}
	},

	created() {
		this.getDeviceList(1)
	},

	activated() {
		if (this.$store.getters.needRefresh) {
			this.getDeviceList(1)
			this.$store.dispatch('account/changeStatus', false)
		}
	},

	methods: {
		getDeviceList(current) {
			const data = this.getRequestParams()
			if (!data) return
			data.current = current
			data.size = this.pageSize
			this.loading = true
			apiGetPressureRegulatorList(data)
				.then(res => {
					this.tableData = res.records || []
					this.total = res.total || 0
					this.currentPage = res.current || current
				})
				.catch(() => {})
				.finally(() => {
					this.loading = false
				})
		},

		getRequestParams() {
			const params = {}
			for (const key in this.params) {
				const value = this.params[key]
				if (!isBlank(value)) {
					if (key === 'installDate' && value.length) {
						params.installStartDate = this.dayjs(value[0]).format('YYYY-MM-DD')
						params.installEndDate = this.dayjs(value[1]).format('YYYY-MM-DD')
					} else {
						params[key] = value
					}
				}
			}
			delete params.installDate
			return params
		},

		handleFilterSearch() {
			this.getDeviceList(1)
		},

		handleFilterReset() {
			this.getDeviceList(1)
		},

		handlePageChange(current) {
			this.getDeviceList(current)
		},

		handleSizeChange(size) {
			this.pageSize = size
			this.getDeviceList(1)
		},

		handleEdit(row) {
			this.$router.push({ name: 'voltageAccountCreate', params: { id: row.id } })
		},

		handleDetail(row) {
			this.$router.push({ name: 'voltageAccountDetails', query: { id: row.id } })
		},

		handleRelationConfig(row) {
			this.$router.push({
				name: 'voltageAccountRelationConfig',
				query: {
					id: row.id,
					regulatorCode: row.regulatorCode,
					collectorDeviceNo: row.collectorDeviceNo,
					collectorDeviceId: row.collectorDeviceId || row.collectorId || row.gatewayDeviceId,
				},
			})
		},

		handleUnbind(row) {
			this.$confirm('确定解绑当前调压器关联设备吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => apiUnbindPressureRegulatorCollector(row.id))
				.then(() => {
					this.$message.success('解绑成功')
					this.getDeviceList(this.currentPage)
				})
				.catch(() => {})
		},
	},

	computed: {
		filterFields() {
			return [
				{
					prop: 'regulatorCode',
					label: '调压器编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'installAddress',
					label: '安装地址',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'brand',
					label: '品牌',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'model',
					label: '型号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'cabinetNo',
					label: '调压柜/箱编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'collectorDeviceNo',
					label: '采集器编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'installDate',
					label: '安装日期',
					type: 'date',
					props: {
						datePickerType: 'daterange',
					},
				},
			].filter(m => !m.hidden)
		},

		userInfo() {
			return this.$store.state.user.userInfo
		},

		columnList() {
			return this.columns.filter(o => o.selected)
		},
	},
}
</script>
<style lang="scss" scoped>
.device-account {
	@include base-button(100px);
	height: 100%;
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	.content {
		flex: 1;
		display: flex;
		padding: 0 12px;
		height: 0;
		.left {
			width: 300px;
			height: 100%;
			padding: 20px 8px 8px 0;
			border-right: 1px solid #f1f1f1;
			& + .right {
				padding-left: 20px;
			}
		}
		.right {
			flex: 1;
			width: 0;
			display: flex;
			height: 100%;
			flex-direction: column;
			.filter {
				display: flex;
				flex-wrap: wrap;
				padding: 12px 0;
			}
			.table {
				flex: 1;
				height: 0;
			}
		}
	}
}
</style>
